import script from "./WorkgroupDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkgroupDetails.vue?vue&type=script&setup=true&lang=js"

import "./WorkgroupDetails.vue?vue&type=style&index=0&id=b1ddccfc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1ddccfc"]])

export default __exports__